<template>
  <div class="dy">
    <el-upload
      ref="imgUpload"
      class="avatar-uploader upload"
      :action="hots"
      name="uploadImg"
      :show-file-list="false"
      :on-success="handleAvatarSuccess">
      <img v-if="imageUrl" :src="imageUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
  import config from '@/lib/http/config'

  export default {
    name: "ImgUpload",
    props: {
      value: {},
      defaultUrl: {
        type: String,
        default: ''
      },
      returnUrl: {
        default: false
      }
    },
    data() {
      return {
        imageUrl: '',
        hots: '',
      }
    },
    methods: {
      getHosts: () => {
        let host = document.location.protocol + '//' + window.location.host;
        if (host.indexOf('127') != -1 || host.indexOf('localhost') != -1) {
          host = config.baseURL;
        }
        return host +  '/api/upload';
      },
      handleAvatarSuccess(res) {
        if (res.result.code == '1') {
          if (this.returnUrl) {
            this.$emit('input', res.url);
          } else {
            this.$emit('input', res.img);
          }
          this.imageUrl = res.url;
        } else {
          console.log('上传图片错误');
        }
      },
    },
    watch: {
      defaultUrl(value) {
        this.imageUrl = value;
      }
    },
    created() {
      this.imageUrl = this.defaultUrl;
      this.hots = this.getHosts();
    }
  }
</script>

<style>
  .el-upload {
    border: 1px solid #ccc
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon, .upload {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
  }

  .avatar {
    /*width: 178px;*/
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/img/ImgUpload.vue